import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import {PAY_ICONS} from '../../../common';

/**
 * Иконки платежек
 *
 * @param {Object} props
 * @param {Array} [props.imgs=['visa','mastercard','youmoney']] Массив плажек для вывода
 * @returns {JSX.Element}
 * @constructor
 */
const PaymentIcons = ({imgs}) => {
    const iconsNames = imgs.map((item) => item.toLowerCase());

    return (
        <div className="payment-wrapper" dir="ltr">
            {iconsNames.map(
                (item) => PAY_ICONS[item] && (
                    <img
                        key={item}
                        src={PAY_ICONS[item]}
                        alt={`payment system ${item}`}
                        className={`payment-icon ${item}`}
                        title={item}
                    />
                )
            )}
        </div>
    );
};

PaymentIcons.propTypes = {
    imgs: PropTypes.array
};

PaymentIcons.defaultProps = {
    imgs: ['visa', 'mastercard', 'youmoney']
};

export default PaymentIcons;
